import { Link, useLocation } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import "./Banner.scss";

const Banner = () => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter(Boolean);

  return (
    <div className="Banner">
      <div className="banner-path">
        <Link to="/">Home</Link>
        <IoIosArrowForward size="13" />

        {pathnames.map((value, index) => {
          const to = "/" + pathnames.slice(0, index + 1).join("/");
          const label = value.replace("-", " ");

          return (
            <span key={to}>
              <Link to={to}>{label}</Link>
              <IoIosArrowForward size="13" />
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default Banner;